import { render, staticRenderFns } from "./MarketFilters.vue?vue&type=template&id=5e8c2ad8&"
import script from "./MarketFilters.vue?vue&type=script&lang=js&"
export * from "./MarketFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports